import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ModeLevelFormatter, ND, RiskEvaluationLevelEnums} from '@pt/pt-models';

@Component({
  selector: 'pt-level-formatter',
  template: `
    <ng-container [ngSwitch]='level'>
      <div class='d-flex align-items-center h-100 pt-level-formatter'>
      <span
        class='low-level'
        [ngClass]='{
        "card-view": mode === ModeLevel.CARD,
        "badge": mode === ModeLevel.BADGE,
        "rounded-pill": mode === ModeLevel.BADGE}'
        [ngStyle]='{"padding": padding}'
        *ngSwitchCase='LevelType.VERY_LOW'
      >{{currentLabel}}</span>

        <span
          class='medium-low-level'
          [ngClass]='{
        "card-view": mode === ModeLevel.CARD,
        "badge": mode === ModeLevel.BADGE,
        "rounded-pill": mode === ModeLevel.BADGE}'
          [ngStyle]='{"padding": padding}'
          *ngSwitchCase='LevelType.LOW'
        >{{currentLabel}}</span>

        <span
          class='medium-level'
          [ngClass]='{
        "card-view": mode === ModeLevel.CARD,
        "badge": mode === ModeLevel.BADGE,
        "rounded-pill": mode === ModeLevel.BADGE}'
          [ngStyle]='{"padding": padding}'
          *ngSwitchCase='LevelType.MEDIUM'
        >{{currentLabel}}</span>

        <span
          class='medium-high-level'
          [ngClass]='{
        "card-view": mode === ModeLevel.CARD,
        "badge": mode === ModeLevel.BADGE,
        "rounded-pill": mode === ModeLevel.BADGE}'
          [ngStyle]='{"padding": padding}'
          *ngSwitchCase='LevelType.HIGH'
        >{{currentLabel}}</span>

        <span
          class='high-level'
          [ngClass]='{
        "card-view": mode === ModeLevel.CARD,
        "badge": mode === ModeLevel.BADGE,
        "rounded-pill": mode === ModeLevel.BADGE}'
          [ngStyle]='{"padding": padding}'
          *ngSwitchCase='LevelType.VERY_HIGH'
        >{{currentLabel}}</span>

        <span
          class='no-level'
          [ngClass]='{
        "card-view": mode === ModeLevel.CARD,
        "badge": mode === ModeLevel.BADGE,
        "rounded-pill": mode === ModeLevel.BADGE}'
          [ngStyle]='{"padding": padding}'
          *ngSwitchDefault
        >{{currentLabel}}</span>
      </div>
    </ng-container>
  `,
  styles: [`
    .pt-level-formatter {
      font-size: 10px;
    }
    .pt-level-formatter span {
      font-size: 90%;
      border-radius: 4.5px;
      /*font-weight: bold;*/
    }
    .no-level {
      background-color: #e9e9e9;
      color: #333333;
    }

    .low-level {
      color: black;
      background-color: var(--ptLow);
    }

    .medium-low-level {
      color: black;
      background-color: var(--ptMediumLow);
    }

    .medium-level {
      color: black;
      background-color: var(--ptMedium);
    }

    .medium-high-level {
      color: black;
      background-color: var(--ptMediumHigh);
    }

    .high-level {
      color: black;
      background-color: var(--ptHigh);
    }

    .card-view {
      display: flex;
      height: 100%;
      width: 100%;
      justify-content: center;
      align-items: center;
    }
  `]
})
export class LevelFormatterComponent implements OnInit {
  @Input() level: RiskEvaluationLevelEnums;
  @Input() label: string;
  @Input() mode: ModeLevelFormatter = ModeLevelFormatter.BADGE;
  @Input() padding: string;
  LevelType = RiskEvaluationLevelEnums;

  currentLabel: string;
  ModeLevel = ModeLevelFormatter;

  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.setLabel();
  }

  private setLabel() {
    switch (true) {
      case !!this.level && !!this.label:
        this.currentLabel = this.label;
        break;
      case !!this.level && !this.label:
        // this.currentLabel = this.level;

        this.translate.stream('RISK_EVALUATION_OPTIONS.' + this.level).subscribe(success => {
          this.currentLabel = success;
        }, () => {
          this.currentLabel = this.level;
        });
        break;
      default:
        this.currentLabel = ND;
    }
  }
}

